import React, {useState} from 'react';
import {Avatar, Button, Popover} from "antd";
import {UserOutlined} from "@ant-design/icons";
import {AccountMenu} from "./AccountMenu";
import {useAuthContext} from "./LauncherAuthContext";
import 'antd/dist/reset.css';

export const AccountButton: React.FC = () => {

    const {user} = useAuthContext();
    const [collapsed, setCollapsed] = useState(false);
    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    return (
        <Popover content={<AccountMenu />} placement={"bottomRight"} trigger={"click"}>
            <Button type="text" icon={<Avatar src={user?.picture} icon={<UserOutlined/>} />} onClick={toggleCollapsed} style={{marginInlineStart: 5}} />
        </Popover>
    );
}

